import { Component, Injector, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Art57Section } from '../../ui/Art57Section/Art57Section';
import { QueryFieldsNode } from '../../ui/Node/QueryFieldsNode';
import { ResultList } from '../../ui/Node/ListEntity/ResultList';


@Component({
  selector: 'app-field-query-type',
  templateUrl: './field-query-type.component.html',
  styleUrl: './field-query-type.component.scss'
})
export class FieldQueryTypeComponent extends FieldType implements OnInit {
  lastSection: boolean = false;
  isChecked: boolean = false;
  constructor(private art57Section: Art57Section) {
    super();
  }
  ngOnInit(): void {
    let selectedNode: any = this.art57Section.getSelectedSection().selectedNode;
    if (selectedNode instanceof QueryFieldsNode) {
      let children = selectedNode.parent?.children?.find((child) => child instanceof ResultList)?.children;
      if (children!.length > 0 && this.formControl.value) {
        this.lastSection = true;
      } 
      this.isChecked = this.formControl.value?this.formControl.value:false;
    }
  }

  manageCheck() {
    this.isChecked = !this.isChecked;
    if (this.isChecked !== this.props['defaultSelection']) {
      this.props['isModified'] = true;
      this.props['defaultSelection'] = true;
    } else {
      this.props['isModified'] = false;
      this.props['defaultSelection'] = false;
    }  

    if (this.IsReadOnly()){
      this.isChecked = true;
    } 

    this.formControl.setValue(this.isChecked);
  }

  IsReadOnly(): boolean {
    let readonly = false;
    if (this.props['readonly'] != undefined) {
      readonly = this.props['readonly']
    }
    return readonly;
  }
}
